export default {
  name: 'UiFormSection',

  // language=HTML
  template: `
    <div class="ui-form-section">
      <div class="ui-form-section__title" slot="title" v-if="label || $slots.label">
        {{ label }}
      </div>
      <div class="ui-form-section__body">
        <slot></slot>
      </div>
    </div>
  `,

  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
